export default __webpack_public_path__ + "static/media/Technical_Architecture.751e8def.png";